// PRODUCT SCRIPT

$(document).ready(function() {

    // PRODUCT SLIDER
    $('.flexslider').flexslider({
        animation: "slide",
        directionNav: false,    
        manualControls: '.photoListBot li'
    });


    // PRODUCT VARIANT CHANGE EVENT
    $('.productBox .formItem .formSelect .variantSelect').change(function(){
        let $thisForm = $(this).closest('form');
        let option_text = '';
        $thisForm.find('.variantSelect').each(function(index){
            option_text += $(this).val();
        });
        if( option_text && option_text != '' ) {
            let variant_val = $thisForm.find('select.product-form__variants option[data-option="'+option_text+'"]').val();
            $thisForm.find('select.product-form__variants').val(variant_val);
        }
    });


    // 
    $('.productList .productBox .formItem.formCheckBox input[type="checkbox"]').change(function(){
        let $thisForm = $(this).closest('form');
        if( $(this).is(':checked') ) {
            $thisForm.find('.btnSubmit .addCartBtn').removeClass('addCartDisable')
        } else {
            $thisForm.find('.btnSubmit .addCartBtn').addClass('addCartDisable')
        }
    });

});